document.addEventListener('DOMContentLoaded', () => {
    const guia = document.getElementById('shack-guia-rapida');
    const btn = document.getElementById('btn-cerrar-guia-shack');
    if (!guia || !btn) return;
    btn.addEventListener('click', () => { guia.style.display = 'none'; });
});
